import { getGameShareUrl } from './shareGameLink'
import { applyRefIdSearchParam } from './refIdShareParam'

/**
 * QR target for the parents banner: links to the game with the resolved `refID`
 * (landingpage-mapping documentId) so the branch mapping survives the stele →
 * phone handoff. Falls back to the current game URL when no stele id is present.
 */
export function buildParentsBannerQrValue(
    svid: string | null,
    refDocumentId?: string | null,
): string {
    if (svid) {
        try {
            const url = new URL(getGameShareUrl())
            applyRefIdSearchParam(url, refDocumentId)
            return url.toString()
        } catch {
            return getGameShareUrl()
        }
    }

    if (typeof window !== 'undefined') {
        return window.location.href
    }

    return getGameShareUrl()
}
